import { pBase } from './.catalog';

export default class pOtpKontrol extends pBase {
  constructor(options: { KullaniciAdi?: string; otp?: string; CepTelefonu?: string }) {
    super();
    this.KullaniciAdi = options.KullaniciAdi;
    this.CepTelefonu = options.CepTelefonu;
    this.otp = options.otp;
  }

  public KullaniciAdi: string | undefined;
  public CepTelefonu: string | undefined;
  public otp: string | undefined;
}
